import React, {memo} from "react"
import {Button} from "scholastic-client-components/src/ui/Button/Button"
import {Trans, useTranslation} from "react-i18next"

interface TFADescriptionProps {
    resendTFA: () => void
    timeLeft: number
    loader: boolean
}

export const TFADescription: React.FC<TFADescriptionProps> = memo(
    ({resendTFA, timeLeft, loader}) => {
        const {t} = useTranslation(["auth_portal"])

        return (
            <div data-cy={"tfa-description"}>
                <span style={{marginBottom: "0.625rem", display: "block"}}>
                    <Trans i18nKey={"auth_portal:auth_page.tfa_sent"} components={{lbr: <br />}} />
                </span>
                <Button
                    data-test="resend-tfa"
                    onClick={resendTFA}
                    disabled={!!timeLeft}
                    loader={loader}
                    text
                >
                    {t("auth_portal:auth_page.resend_tfa_button", {count: timeLeft})}
                </Button>
            </div>
        )
    }
)
